package com.example.mystybag.appCore.views.addMerchantLocation

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.ui.draw.clip
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.Modifier
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationAddDescriptionViewModel
import com.example.mystybag.appCore.model.addMerchantLocation.ProductRowUIModel
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.common.ui.components.custom.DefaultCircleShapedTextField
import com.example.mystybag.common.ui.components.custom.CheckIcon
import com.example.mystybag.common.ui.components.custom.ImageDescriptionView
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.common.views.CommonBottomSheetFactory
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p1
import com.example.mystybag.core.ui.theme.LocalTheme.p2
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p28
import com.example.mystybag.core.ui.theme.LocalTheme.p40
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.stringResource
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.ui.Alignment
import dev.icerock.moko.resources.compose.painterResource

@Composable
fun MerchantRegistrationAddDescriptionView(viewModel: MerchantRegistrationAddDescriptionViewModel) {
    val density = LocalDensity.current
    var businessCategoryFieldWidth by remember { mutableStateOf(0.dp) }

    BottomSheetUIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        bottomSheetFactory = {
            CommonBottomSheetFactory(it)
        }
    ) { uiState ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .imePadding()
        ) {
            Column(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth()
                    .verticalScroll(rememberScrollState())
                    .padding(horizontal = p16),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(p24)
            ) {
                Texts.DisplaySmall(
                    text = stringResource(SR.strings.add_product_description),
                    textAlign = TextAlign.Left,
                    modifier = Modifier.fillMaxWidth()
                )

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { viewModel.showBusinessCategoryPicker() }
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .onGloballyPositioned { coordinates ->
                                businessCategoryFieldWidth = with(density) { coordinates.size.width.toDp() }
                            }
                    ) {
                        DefaultCircleShapedTextField(
                            value = uiState.value.selectedBusinessCategory?.title ?: "",
                            onValueChange = {},
                            label = stringResource(SR.strings.select_store_type),
                            modifier = Modifier.fillMaxWidth(),
                            readOnly = true,
                            enabled = true,
                            isError = uiState.value.requiredBusinessCategoryError,
                            errorText = "",
                            backgroundColor = AppTheme.current.colors.surface,
                            borderColor = AppTheme.current.colors.outline,
                            trailingIcon = {
                                Image(
                                    painter = painterResource(SRC.images.combobox_arrow_down_green),
                                    contentDescription = sharedString(SR.strings.select_business_category),
                                    contentScale = ContentScale.Fit,
                                    modifier = Modifier.size(p16)
                                )
                            }
                        )
                        Box(
                            modifier = Modifier
                                .matchParentSize()
                                .clickable { viewModel.showBusinessCategoryPicker() }
                        )

                        DropdownMenu(
                            expanded = uiState.value.showBusinessCategoryPicker,
                            onDismissRequest = viewModel::hideBusinessCategoryPicker,
                            containerColor = AppTheme.current.colors.surface,
                            shape = RoundedCornerShape(p20),
                            offset = DpOffset(x = 0.dp, y = 4.dp),
                            modifier = Modifier
                                .then(
                                    if (businessCategoryFieldWidth > 0.dp) Modifier.width(businessCategoryFieldWidth)
                                    else Modifier
                                )
                                .height(p40 * 8)
                        ) {
                            uiState.value.businessCategories.forEachIndexed { index, category ->
                                val isSelected = uiState.value.selectedBusinessCategory?.id == category.id
                                DropdownMenuItem(
                                    text = {
                                        Texts.BodyLarge(
                                            text = category.title,
                                            color = if (isSelected) AppTheme.current.colors.primary else AppTheme.current.colors.onSurface
                                        )
                                    },
                                    onClick = {
                                        viewModel.selectBusinessCategory(category.id, category.title)
                                        viewModel.hideBusinessCategoryPicker()
                                    },
                                    trailingIcon = {
                                        if (isSelected) {
                                            CheckIcon(
                                                contentDescription = sharedString(SR.strings.selected),
                                                tint = AppTheme.current.colors.primary
                                            )
                                        }
                                    }
                                )
                                if (index < uiState.value.businessCategories.lastIndex) {
                                    HorizontalDivider(
                                        thickness = 1.dp,
                                        color = AppTheme.current.colors.outline
                                    )
                                }
                            }
                        }
                    }

                }

                val coverUrls = uiState.value.selectedBusinessCategory?.coverImageUrls ?: emptyList()
                if (coverUrls.isNotEmpty()) {
                    SectionHeader(title = stringResource(SR.strings.choose_business_image))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .horizontalScroll(rememberScrollState()),
                        horizontalArrangement = Arrangement.spacedBy(p8)
                    ) {
                        coverUrls.forEachIndexed { index, url ->
                            CoverPresetUrlCard(
                                imageUrl = url,
                                isSelected = uiState.value.selectedPreviewImageIndex == index,
                                onClick = { viewModel.selectPreviewImage(index) },
                                modifier = Modifier.width(112.dp)
                            )
                        }
                    }
                    if (uiState.value.requiredCoverPreviewError) {
                        Texts.BodySmall(
                            text = stringResource(SR.strings.please_select_business_cover_image),
                            color = AppTheme.current.colors.error,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = p8)
                        )
                    }
                }

                SectionHeader(title = stringResource(SR.strings.describe_your_products))

                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(p16),
                    horizontalAlignment = Alignment.Start
                ) {
                    uiState.value.productRows.forEachIndexed { index, row ->
                        ProductRow(
                            row = row,
                            canDelete = uiState.value.productRows.size > 1,
                            productNameError = index in uiState.value.requiredProductNameRows,
                            gramsError = index in uiState.value.requiredProductGramsRows,
                            onNameChange = { viewModel.updateProductName(index, it) },
                            onGramsChange = { viewModel.updateGrams(index, it) },
                            onDelete = { viewModel.removeProductRow(index) }
                        )
                    }

                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .clip(RoundedCornerShape(p40))
                                .background(AppTheme.current.colors.primaryContainer)
                                .clickable(
                                    enabled = !uiState.value.isLoading,
                                    onClick = viewModel::addProductRow
                                )
                                .padding(horizontal = p20, vertical = p12),
                            contentAlignment = Alignment.Center
                        ) {
                            Texts.TitleMedium(
                                text = stringResource(SR.strings.add_product_item),
                                color = AppTheme.current.colors.onPrimaryContainer
                            )
                        }
                    }
                }
            }

            DefaultButton(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = p16, vertical = p16),
                type = DefaultButtonType.PRIMARY,
                caption = stringResource(SR.strings.continue_camel_case),
                callback = viewModel::onContinue,
                enabled = !uiState.value.isLoading
            )
        }
    }
}

@Composable
private fun SectionHeader(title: String) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(p12)
    ) {
        Texts.LabelMedium(
            text = title,
            color = AppTheme.current.colors.onSurfaceVariant
        )
        HorizontalDivider(
            color = AppTheme.current.colors.outline,
            thickness = p1
        )
    }
}

@Composable
private fun CoverPresetUrlCard(
    imageUrl: String,
    isSelected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .aspectRatio(121f / 162f)
            .clip(RoundedCornerShape(p28))
            .border(
                width = if (isSelected) p2 else p1,
                color = if (isSelected) AppTheme.current.colors.primary else AppTheme.current.colors.outline.copy(alpha = 0.16f),
                shape = RoundedCornerShape(p28)
            )
            .clickable(onClick = onClick)
    ) {
        ImageDescriptionView(
            modifier = Modifier.fillMaxSize(),
            image = ImageDescription(link = imageUrl, icon = null)
        )
    }
}

@Composable
private fun ProductRow(
    row: ProductRowUIModel,
    canDelete: Boolean,
    productNameError: Boolean,
    gramsError: Boolean,
    onNameChange: (String) -> Unit,
    onGramsChange: (String) -> Unit,
    onDelete: () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(p16),
        verticalAlignment = Alignment.CenterVertically
    ) {
        DefaultCircleShapedTextField(
            modifier = Modifier.weight(1f),
            value = row.productName,
            onValueChange = onNameChange,
            label = stringResource(SR.strings.product_name),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text),
            isError = productNameError,
            errorText = ""
        )

        DefaultCircleShapedTextField(
            modifier = Modifier.width(128.dp),
            value = row.grams,
            onValueChange = onGramsChange,
            label = stringResource(SR.strings.grams),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
            isError = gramsError,
            errorText = ""
        )

        Box(
            modifier = Modifier
                .size(p40)
                .clip(CircleShape)
                .background(AppTheme.current.colors.surfaceContainerHighest)
                .then(
                    if (canDelete) Modifier.clickable(onClick = onDelete)
                    else Modifier
                ),
            contentAlignment = Alignment.Center
        ) {
            Texts.TitleLarge(
                text = "-",
                color = AppTheme.current.colors.error
            )
        }
    }
}


